<template>
  <div class="warehouse-manage">
    <div class="search-warehouse">
      <div class="search">
        <span class="search-title">仓库名称：</span>
        <el-input class="white" v-model="warehouseName" placeholder="请输入仓库名称"></el-input>
        <el-button icon="el-icon-search" class="btn-blue" @click="searchWarehouse">搜索</el-button>
      </div>
      <div class="btn-container">
        <div class="warehouse-mapping" @click="openWarehouseMapping">
          <span class="warehouse-mapping-img"></span>
          <span>仓库映射</span>
        </div>
        <div class="add-customer" @click="addWarehouse">
          <span class="add-rectangle"></span>
          <span>新增仓库</span>
        </div>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="仓库名称"></el-table-column>
        <!-- <el-table-column prop="bcPercent" label="toC业务比重">
          <template slot-scope="scope">
            <span>{{ scope.row.bcPercent }}%</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="orderQualityVal" label="成本分摊规则"></el-table-column>
        <el-table-column prop="billGenerationRulesVal" label="日账单生成规则"></el-table-column>
        <el-table-column prop="area" label="面积"></el-table-column>
        <el-table-column prop="rentPriceMonth" label="场租月单价"></el-table-column>
        <el-table-column prop="attendanceRule" label="考勤规制"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="updateWarehouse(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增/编辑 -->
    <el-drawer class="save-warehouse-drawer" :title="warehouseForm.id ? '编辑' : '新增'" :visible.sync="drawer"
      :wrapperClosable="false" :before-close="closeWarehouseDialog">
      <el-form ref="warehouseForm" :rules="warehouseFormRules" :model="warehouseForm">
        <div class="row">
          <el-form-item label="仓库名称" prop="name">
            <el-input v-model="warehouseForm.name" class="white" placeholder="请输入仓库名称"></el-input>
          </el-form-item>
          <el-form-item label="场租月单价" prop="rentPriceMonth">
            <el-input v-model="warehouseForm.rentPriceMonth" @input="rentPriceMonthInput" class="white"
              placeholder="请输入场租月单价"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="toC业务比重（%）" prop="bcPercent">
            <el-input v-model="warehouseForm.bcPercent" @input="bcPercentInput" class="white"
              placeholder="请输入0-100之间数值"></el-input>
          </el-form-item>
          <el-form-item label="面积" prop="area">
            <el-input v-model="warehouseForm.area" @input="areaInput" class="white" placeholder="请输入面积"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="成本分摊规则" prop="costAllocationRules">
            <el-radio-group v-model="warehouseForm.costAllocationRules">
              <el-radio :label="1">订单数量</el-radio>
              <el-radio :label="2">商品件数</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考勤规则" prop="attendanceType">
            <el-radio-group v-model="warehouseForm.attendanceType">
              <el-radio :label="0">排班</el-radio>
              <el-radio :label="1">调休</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="日账单生成规则" prop="billGenerateType">
            <el-radio-group v-model="warehouseForm.billGenerateType">
              <el-radio :label="1">定时生成</el-radio>
              <el-radio :label="2">补录生成</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="定时设置" prop="billGenerateTimeRate">
            <el-radio-group v-model="warehouseForm.billGenerateTimeRate">
              <el-radio :label="1">
                T+1
                <span class="delay">（延后1天）</span>
              </el-radio>
              <el-radio :label="2">
                T+2
                <span class="delay">（延后2天）</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="closeWarehouseDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveWarehouse('warehouseForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 仓库映射 -->
    <el-drawer class="mapping-drawer" title="物流映射" :visible.sync="mappingDrawer" :wrapperClosable="false"
      :before-close="handleCloseMappingDrawer">
      <div class="mapping-content">
        <el-form ref="mappingForm" :model="mappingForm">
          <p class="sub-title">创建映射</p>
          <el-form-item label="仓库名称" prop="warehouseId">
            <el-select v-model="mappingForm.warehouseId" filterable placeholder="请选择" class="white">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="映射仓库名称" prop="mappingWarehouseName">
            <el-input v-model="mappingForm.mappingWarehouseName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-mapping" @click="matchingMapping">匹配映射</el-button>
          </el-form-item>
        </el-form>

        <div class="mapping-container">
          <div class="table">
            <el-table ref="table" :data="mappingTableData" style="width: 100%">
              <el-table-column prop="warehouseName" label="仓库名称"></el-table-column>
              <el-table-column prop="mappingWarehouseName" label="映射仓库名称"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button class="btn-text" type="text" @click="delMapping(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseMappingDrawer">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getInteger, getDecimal } from "common/js/util";
import warehouseMixins from 'common/mixins/warehouse.js'
import WarehouseManage from "models/warehouse-manage";
const warehouseManage = new WarehouseManage();
export default {
  mixins: [warehouseMixins],
  data() {
    return {
      warehouseName: "",
      searchWarehouseName: "",
      tableData: [],
      drawer: false,
      warehouseForm: {
        id: "",
        name: "",
        // 2C业务比重
        bcPercent: "",
        area: "",
        // 场租月单价
        rentPriceMonth: "",
        // 考勤规则
        attendanceType: 0,
        // 成本分摊规则
        costAllocationRules: 1,
        // 日账单生成规则
        billGenerateType: 1,
        // 定时设置
        billGenerateTimeRate: 1,
      },
      warehouseFormRules: {
        name: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
        bcPercent: [
          { required: true, message: "请输入2C业务比重", trigger: "blur" }
        ],
        area: [{ required: true, message: "请输入面积", trigger: "blur" }],
        rentPriceMonth: [
          { required: true, message: "请输入场租月单价", trigger: "blur" }
        ],
        attendanceType: [
          {
            required: true,
            message: "请选择计费类型",
            trigger: "change"
          }
        ],
        costAllocationRules: [
          {
            required: true,
            message: "请选择成本分摊规则",
            trigger: "change"
          }
        ],
        billGenerateType: [
          {
            required: true,
            message: "请选择日账单生成规则",
            trigger: "change"
          }
        ],
        billGenerateTimeRate: [
          {
            required: true,
            message: "请选择定时设置",
            trigger: "change"
          }
        ]
      },
      costAllocationVal: {
        1: "订单数量",
        2: "商品件数"
      },
      // 账单生成规则状态转译
      billGenerationRulesObj: {
        1: '定时生成',
        2: '补录生成'
      },


      // 物流映射开关
      mappingDrawer: false,
      mappingForm: {
        warehouseId: null,
        mappingWarehouseName: null
      },
      mappingTableData: []
    };
  },
  watch: {
    drawer: {
      handler(value) {
        if (!value) {
          this.$refs["warehouseForm"].resetFields();
          this.warehouseForm.id = "";
          this.warehouseForm.name = "";
          this.warehouseForm.bcPercent = "";
          this.warehouseForm.area = "";
          this.warehouseForm.rentPriceMonth = "";
          this.warehouseForm.attendanceType = 0;
          this.warehouseForm.costAllocationRules = 1;
          this.warehouseForm.billGenerateType = 1;
          this.warehouseForm.billGenerateTimeRate = 1;
        }
      }
    }
  },
  async created() {
    this.initWarehouseList();
    await this.initAsyncWarehouse();
    this.initMappingList()
  },
  methods: {
    /**
     * @desc 获取仓库列表数据
     */
    initWarehouseList() {
      let name = this.searchWarehouseName;
      warehouseManage.getWarehouseList(name).then(res => {
        let arr = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          obj.bcPercent = Number(value.bcPercent*100);
          obj.area = value.area;
          obj.rentPriceMonth = value.rentPriceMonth;
          obj.attendanceType = value.attendanceType;
          obj.attendanceRule = value.attendanceType === 0 ? "排班" : "调休";
          obj.orderQualityVal = this.costAllocationVal[value.orderQuality];
          obj.billGenerationRulesVal = this.billGenerationRulesObj[value.billGenerateType];
          obj.billGenerateType = value.billGenerateType;
          obj.billGenerateTimeRate = value.billGenerateTimeRate;
          obj.costAllocationRules = value.orderQuality;
          arr.push(obj);
        });
        this.tableData = arr;
      });
    },

    /**
     * @desc 获取详情
     */
    initDetails(id) {
      warehouseManage.postDetailsWarehouse(id).then(res => {
        if (res.success) {
          let { id, name, 
            bcPercent, 
            area, rentPriceMonth, attendanceType, orderQuality, 
            billGenerateType, billGenerateTimeRate 
          } = res.result
          this.warehouseForm.id = id;
          this.warehouseForm.name = name;
          this.warehouseForm.bcPercent = Number(bcPercent*100);
          this.warehouseForm.area = area;
          this.warehouseForm.rentPriceMonth = rentPriceMonth;
          this.warehouseForm.attendanceType = attendanceType;
          this.warehouseForm.costAllocationRules = orderQuality;
          this.warehouseForm.billGenerateType = billGenerateType;
          this.warehouseForm.billGenerateTimeRate = billGenerateTimeRate;
          this.addWarehouse();
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /**
     * @desc 搜索
     */
    searchWarehouse() {
      this.searchWarehouseName = this.warehouseName;
      this.initWarehouseList();
    },

    /**
     * @desc 开启新增抽屉
     */
    addWarehouse() {
      this.drawer = true;
    },

    closeWarehouseDialog() {
      this.drawer = false;
    },

    /**
     * @desc 保存仓库
     */
    saveWarehouse(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.warehouseForm.id) {
            let data = {};
            data.id = this.warehouseForm.id;
            data.name = this.warehouseForm.name;
            data.bcPercent = this.warehouseForm.bcPercent;
            data.area = this.warehouseForm.area;
            data.rentPriceMonth = this.warehouseForm.rentPriceMonth;
            data.attendanceType = this.warehouseForm.attendanceType;
            data.orderQuality = this.warehouseForm.costAllocationRules;
            data.billGenerateType = this.warehouseForm.billGenerateType;
            data.billGenerateTimeRate = this.warehouseForm.billGenerateTimeRate;
            warehouseManage.postUpdateWarehouse(data).then(res => {
              if (res.success) {
                this.initWarehouseList();
                this.$message.success("修改成功");
                this.closeWarehouseDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.warehouseForm.name;
            data.bcPercent = this.warehouseForm.bcPercent;
            data.area = this.warehouseForm.area;
            data.rentPriceMonth = this.warehouseForm.rentPriceMonth;
            data.attendanceType = this.warehouseForm.attendanceType;
            data.orderQuality = this.warehouseForm.costAllocationRules;
            data.billGenerateType = this.warehouseForm.billGenerateType;
            data.billGenerateTimeRate = this.warehouseForm.billGenerateTimeRate;
            warehouseManage.postAddWarehouse(data).then(res => {
              if (res.success) {
                this.initWarehouseList();
                this.$message.success("新增成功");
                this.closeWarehouseDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    updateWarehouse(row) {
      this.initDetails(row.id)
    },

    /**
     * @desc 2C业务比重限制整数且小于等于100
     */
    bcPercentInput() {
      let bcPercent = this.warehouseForm.bcPercent;
      if (Number(getInteger(bcPercent)) <= 100) {
        this.warehouseForm.bcPercent = getInteger(bcPercent);
      } else {
        this.warehouseForm.bcPercent = 100;
      }
    },

    /**
     * @desc 限制面积输入,保留2位小数
     */
    areaInput() {
      let area = this.warehouseForm.area;
      this.warehouseForm.area = getDecimal(area);
    },

    /**
     * @desc 场租月单价输入,保留2位小数
     */
    rentPriceMonthInput() {
      let rentPriceMonth = this.warehouseForm.rentPriceMonth;
      this.warehouseForm.rentPriceMonth = getDecimal(rentPriceMonth);
    },

    /** 
     * @desc 开启仓库映射
    */
    openWarehouseMapping() {
      this.mappingDrawer = true
    },


    handleCloseMappingDrawer() {
      this.mappingForm.warehouseId = null
      this.mappingForm.mappingWarehouseName = null
      this.mappingDrawer = false
    },

    /** 
     * @description 删除映射仓库
    */
    delMapping(row) {
      this.$confirm("删除后，该映射关系将失效，请确认", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        warehouseManage.postDelMappingWarehouseList(row.id).then(res => {
          if (res.success) {
            this.initMappingList()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },


    /** 
     * @desc 映射列表
    */
    initMappingList() {
      warehouseManage.getMappingWarehouseList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            let wareshouseObj = this.warehouseList.find(item => { return i.warehouseId === item.id })
            obj.warehouseId = i.warehouseId
            obj.warehouseName = wareshouseObj.name
            obj.mappingWarehouseName = i.name
            arr.push(obj)
          })
          this.mappingTableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @description 获取匹配数据
    */
    matchingMapping() {
      let warehouseId = this.mappingForm.warehouseId
      let name = this.mappingForm.mappingWarehouseName
      let data = {
        warehouseId,
        name
      }
      warehouseManage.postSaveMappingWarehouseList(data).then(res => {
        if (res.success) {
          this.$message.success('匹配成功')
          this.initMappingList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/warehouse/base-info.scss';
</style>
